import { useGetPublicProfile } from '@hooks/TRPC_Hooks/useGetPublicProfile';
import { useTranslation } from '@hooks/useTranslation';
import { purchase } from '@specs/specs';
import cn from 'classnames';
import { FC } from 'react';
import s from './toyHistoryItem.module.scss';
import moment from 'moment';
import { Avatar } from '@components/UIKit/Avatar/Avatar';
import { Currency } from '@components/UIKit/Currency/Currency';
import { ToyHistoryItemLoader } from '@components/Cards/ToyHistoryItem/ToyHistoryItemLoader';
interface ToyHistoryItemProps extends purchase {}
export const ToyHistoryItem: FC<ToyHistoryItemProps> = ({
  profileShortID,
  price,
  date: _date,
  currency,
  type
}) => {
  const {
    translate: tr
  } = useTranslation();
  const {
    data: profile,
    isLoading
  } = useGetPublicProfile({
    shortId: profileShortID
  });
  if (isLoading) return <ToyHistoryItemLoader />;
  if (!profile) return null;
  const {
    shortid
  } = profile;
  const date = moment(_date).format('DD.MM.YYYY');
  const time = moment(_date).format('HH:mm');
  return <div className={s.toyHistoryItem} data-sentry-component="ToyHistoryItem" data-sentry-source-file="ToyHistoryItem.tsx">
            <div className={s.toyHistoryItem__body}>
                <Avatar profile={profile} srcSet={[{
        height: 40,
        width: 40,
        minMedia: 0
      }]} isLoading={false} data-sentry-element="Avatar" data-sentry-source-file="ToyHistoryItem.tsx" />
                <div className={s.toyHistoryItem__main}>
                    <div className={cn(s.toyHistoryItem__name, '_ellipsis')}>
                        {shortid}
                    </div>
                    <div className={s.toyHistoryItem__date}>
                        {tr({
            id: 'toy.page.history.date.text'
          }, {
            date,
            time
          })}
                    </div>
                </div>
                <div className={s.toyHistoryItem__right}>
                    {type === 'COLLECTED_TOY' ? tr({
          id: 'collected'
        }) : <Currency amount={price} currency={currency} />}
                </div>
            </div>
        </div>;
};